import React from 'react';
import MetaTags from '../meta/MetaTags.jsx';
import './faq.css';

export default function Faq() {
  return (
    <>
      <MetaTags profileKey="faq" />
      <main className="faq-page" aria-labelledby="faq-page-title">
        <section className="section-faq-header">
          <h1 id="faq-page-title" className="section-faq-title">Frequently Asked Questions</h1>
          <p className="section-faq-subtitle">
            PartyDecider is a modern event planning platform that combines elegant digital invitations, collaborative
            planning tools, high-profile guest management and shared timelines in one smooth and intuitive experience.
            It brings structure to planning and turns coordination into a smooth, stylish experience everyone enjoys.
          </p>
        </section>

        <section className="section-faq-list" aria-label="PartyDecider FAQ">
          <div className="block-faq">
            <h2 className="block-faq-question">What is PartyDecider?</h2>
            <p className="block-faq-answer">
              PartyDecider is a digital invitation and event-planning platform offering RSVP tools, trip planners,
              tasks, polls, budgets, VIP guest modes, and shared timelines.
            </p>
          </div>

          <div className="block-faq">
            <h2 className="block-faq-question">Is PartyDecider free?</h2>
            <p className="block-faq-answer">
              Yes. Core planning features are free. Premium VIP features are coming soon.
            </p>
          </div>

          <div className="block-faq">
            <h2 className="block-faq-question">Can I plan trips with friends?</h2>
            <p className="block-faq-answer">
              Yes. PartyDecider includes trip planning, polls, shared timelines, payment tracking,
              co-hosting, and budget tools.
            </p>
          </div>

          <div className="block-faq">
            <h2 className="block-faq-question">Are my invitations private?</h2>
            <p className="block-faq-answer">
              PartyDecider uses secure Firebase Authentication and encrypted Firestore storage to protect your event data.
            </p>
          </div>

          <div className="block-faq">
            <h2 className="block-faq-question">Does PartyDecider support VIP or invite-only events?</h2>
            <p className="block-faq-answer">
              Yes. VIP and invite-only modes allow hosts to restrict access to designated guests only.
            </p>
          </div>
        </section>
      </main>
    </>
  );
}
